import styled from "styled-components";
import { COLORS } from "../../../../../assets/constants/styles";

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SectionHeading = styled.div`
  font-weight: 600;
  color: ${COLORS.black};
  margin-bottom: 0.25rem;
`;

export const SectionBox = styled.div`
  background-color: ${COLORS.white};
  border-radius: 0.75rem;
  padding: 1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: ${COLORS.black};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const EmptyStateMessage = styled.div`
  font-style: italic;
  color: ${COLORS.grey};
  text-align: center;
  padding: 0.5rem;
`;
